module.exports = __webpack_public_path__ + "img/gainsbourg.32bdd613.jpg";